import React from "react";

// Pictogrammes simplifiés des plateformes média pour "Media Vibes" — volontairement PAS les
// logos officiels (ni leurs couleurs de marque) : des tracés épurés et reconnaissables, dans le
// même registre qu'une icône générique "partager vers X" utilisée par n'importe quelle app.
// Ne jamais remplacer par les vrais logos/couleurs officiels.

export type MediaProviderId = "youtube" | "spotify" | "deezer" | "netflix" | "hbo" | "prime" | "canal";

export const PROVIDER_ORDER: MediaProviderId[] = ["netflix", "hbo", "prime", "canal", "spotify", "deezer", "youtube"];

export const PROVIDER_META: Record<MediaProviderId, { label: string; oembed: boolean; verb: "Regarder" | "Écouter"; grad: [string, string] }> = {
  youtube: { label: "YouTube", oembed: true, verb: "Regarder", grad: ["#2E2E2E", "#0F0F0F"] },
  spotify: { label: "Spotify", oembed: true, verb: "Écouter", grad: ["#1F3D2E", "#0B1A12"] },
  deezer: { label: "Deezer", oembed: true, verb: "Écouter", grad: ["#2B2140", "#120C1E"] },
  netflix: { label: "Netflix", oembed: false, verb: "Regarder", grad: ["#3A0E12", "#140507"] },
  hbo: { label: "HBO", oembed: false, verb: "Regarder", grad: ["#241B3D", "#0C0917"] },
  prime: { label: "Prime Video", oembed: false, verb: "Regarder", grad: ["#0E2A3A", "#050F16"] },
  canal: { label: "Canal+", oembed: false, verb: "Regarder", grad: ["#2A2A2A", "#0A0A0A"] },
};

export function PlatformLogo({ id, size = 20, color = "white" }: { id: MediaProviderId; size?: number; color?: string }) {
  const props = { width: size, height: size, viewBox: "0 0 24 24", fill: color };
  switch (id) {
    case "youtube":
      return (
        <svg {...props}>
          <rect x="2" y="5.5" width="20" height="13" rx="4" fill="none" stroke={color} strokeWidth="1.8" />
          <path d="M10 9.2v5.6l5-2.8z" />
        </svg>
      );
    case "prime":
      return (
        <svg {...props}>
          <path d="M9 6.5v11l8-5.5z" />
          <path d="M4 18c4 2.4 12 2.4 16 0" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      );
    case "netflix":
      return (
        <svg {...props}>
          <path d="M6 3h3.1l5.7 12.3V3H18v18h-3.1L9.2 8.7V21H6z" />
        </svg>
      );
    case "canal":
      return (
        <svg {...props}>
          <rect x="2.5" y="2.5" width="19" height="19" rx="6" fill="none" stroke={color} strokeWidth="1.8" />
          <path d="M12 7v10M7 12h10" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
        </svg>
      );
    case "hbo":
      return (
        <svg {...props}>
          <rect x="2.5" y="2.5" width="19" height="19" rx="6" fill="none" stroke={color} strokeWidth="1.8" />
          <path d="M7.5 7.5v9M12 7.5v9M16.5 7.5v9M7.5 12h4.5M12 12h4.5" stroke={color} strokeWidth="1.7" strokeLinecap="round" fill="none" />
        </svg>
      );
    case "spotify":
      return (
        <svg {...props}>
          <circle cx="12" cy="12" r="9.5" fill="none" stroke={color} strokeWidth="1.8" />
          <path d="M7 10.2c3.2-1 7-.7 9.6.9M7.6 13.2c2.6-.75 5.6-.5 7.8.75M8.2 16c2-.55 4.3-.4 6 .55" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    case "deezer":
      return (
        <svg {...props}>
          <rect x="2.5" y="13" width="3.6" height="5.5" rx="0.8" />
          <rect x="7.6" y="10" width="3.6" height="8.5" rx="0.8" />
          <rect x="12.7" y="6.5" width="3.6" height="12" rx="0.8" />
          <rect x="17.8" y="9" width="3.6" height="9.5" rx="0.8" />
        </svg>
      );
  }
}
